import React, {
  FC,
  memo,
  useCallback,
}                          from 'react';
import { Breakpoint }      from '@material-ui/core/styles/createBreakpoints';
import { ICardAdValues }   from '@typings/nationalAdManagement';
import {
  useSaveCardAd,
  useFetchCardAd,
}                          from '@modules/nationalAdManager/queries/nationalAdQueries';
import { Loader }          from '@components/Loader/Loader';
import { AdEditorWrapper } from '@modules/nationalAdManager/components/AdEditorWrapper';

interface IProps {
  width        : Breakpoint;
  id?          : string;
  onCancelEdit : () => void;
}
const AdEditor: FC<IProps> = ({ width, id, onCancelEdit }) => {
  // #region API INTEGRATION
  const {
    data: currentAd,
    isLoading,
  } = useFetchCardAd(
    id as string,
    { enabled: !!id },
  );

  const { mutateAsync: saveAd } = useSaveCardAd();
  // #endregion

  const onSaveAd = useCallback(
    async (values: ICardAdValues): Promise<void> => {
      await saveAd(values);
      setTimeout(onCancelEdit, 2000);
    },
    [onCancelEdit, saveAd],
  );

  if (isLoading) {
    return <Loader />;
  }

  return (
    <AdEditorWrapper
      width    = {width}
      adData   = {currentAd ?? null}
      onSubmit = {onSaveAd}
      onCancel = {onCancelEdit}
    />
  );
};

export const AdEditorContainer = memo(AdEditor);
